export const GET_ENTITIES = "GET_ENTITIES";
export const GET_ENTITIES_SUCCESS = "GET_ENTITIES_SUCCESS";
export const GET_ENTITIES_ERROR = "GET_ENTITIES_ERROR";
export const GET_ENTITY_DETAILS = "GET_ENTITY_DETAILS";
export const GET_ENTITY_DETAILS_SUCCESS = "GET_ENTITY_DETAILS_SUCCESS";
export const GET_ENTITY_DETAILS_ERROR = "GET_ENTITY_DETAILS_ERROR";
export const GET_ENTITY_DETAILS_RESET = "GET_ENTITY_DETAILS_RESET";
